import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { getBasename } from '@/utils/url';
import Dashboard from './Dashboard';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [sessionChecked, setSessionChecked] = useState(false);
  const routerBasename = getBasename();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Verificar se é fluxo de confirmação de email (query params)
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const type = urlParams.get('type');
        const next = urlParams.get('next') || '/dashboard';

        if (token && type) {
          // Fluxo de confirmação de email
          const { data, error } = await supabase.auth.verifyOtp({
            token_hash: token,
            type: type as any,
          });

          if (error) {
            console.error('Erro na verificação:', error);
            navigate('/auth/error');
            return;
          }

          if (data.user) {
            // Buscar perfil do usuário
            const { data: profileData, error: profileError } = await supabase
              .from('profiles')
              .select('*')
              .eq('id', data.user.id)
              .single();

            if (profileData && !profileData.optional_fields_completed && (profileData.wizard_views ?? 0) < 3) {
              // Store flag in sessionStorage to show wizard on dashboard
              sessionStorage.setItem('showWizard', 'true');
            }
            
            navigate(next, { replace: true });
          } else {
            navigate('/auth/error');
          }
          setSessionChecked(true);
          return;
        }

        // Fluxo PKCE (hash params) - código original
        const hash = window.location.hash.substring(1);
        const hashParams = new URLSearchParams(hash);
        const access_token = hashParams.get('access_token');
        const refresh_token = hashParams.get('refresh_token');
        const hashType = hashParams.get('type');

        // Se for um logout, apenas redireciona para home
        if (hashType === 'signout') {
          navigate(routerBasename, { replace: true });
          return;
        }

        // Se não houver tokens, redireciona para home
        if (!access_token || !refresh_token) {
          navigate('/', { replace: true });
          return;
        }

        // Se for um login e tiver tokens, configura a sessão
        supabase.auth.setSession({
          access_token,
          refresh_token,
        }).then(async ({ data: { session } }) => {
          if (session) {
            // Buscar perfil do usuário
            const { data, error } = await supabase
              .from('profiles')
              .select('*')
              .eq('id', session.user.id)
              .single();

            if (data && !data.optional_fields_completed && (data.wizard_views ?? 0) < 3) {
              // Store flag in sessionStorage to show wizard on dashboard
              sessionStorage.setItem('showWizard', 'true');
            }
            
            navigate('/dashboard', { replace: true });
          } else {
            navigate('/', { replace: true });
          }
          setSessionChecked(true);
        }).catch(() => {
          navigate('/', { replace: true });
        });
      } catch (error) {
        console.error('Erro no callback:', error);
        navigate('/auth/error');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  // Se ainda não verificou a sessão, mostra loading
  if (!sessionChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#160C0C] text-white text-lg">
        Processing authentication...
      </div>
    );
  }

  return null;
} 